import {
  Image,
  ImageBackground,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {createStyles} from '../../utils/createStyles';
import React, {useEffect, useRef, useState, useMemo, useCallback} from 'react';
import {CommonActions, useNavigation, useRoute} from '@react-navigation/native';
import AgreeNegotiate, {
  AgreeNegotiateRef,
} from '../AViewComponents/AgreeNegotiate/AgreeNegotiate';
import LinearGradient from 'react-native-linear-gradient';
import {Button, Input} from '@rneui/themed';
import {Controller, FieldError, useForm} from 'react-hook-form';
import Toast from 'react-native-toast-message';
import {checkSN, registerApi, sendCodeApi, updateUserApi} from '../../API/user';
import useGetDeviceInfo from '../../hooks/useGetDeviceInfo';
import {RouteProp} from '@react-navigation/core/src/types';
import {RouteParamsList} from '../../router/ParamsList';
import {useAppSelector} from '../../store/hooks';
import {saveUserInfo, selectUserInfo} from '../../store/user';
import {useDispatch} from 'react-redux';
import GradeSelector from '../../components/GradeSelector';
import {getCurriculumSetupInfos, Stage, Grade, Term} from '../../API/newHome';
import {CurriculumSetup} from '../../components/GradeSelector';

interface itemProps {
  icon?: string;
  children?: any;
  itemStyle?: any[];
}

// 将 ItemComponent 移出主组件，使用 memo 包裹
const ItemComponent = React.memo(({icon, children, itemStyle}: itemProps) => (
  <View style={[styles.itemComponentBox, itemStyle]}>
    {icon ? (
      <Image style={styles.itemComponentImage} source={{uri: icon}} />
    ) : null}
    <View>{children}</View>
  </View>
));

// 定义表单数据类型
interface FormData {
  name: string;
  gender: number;
  grade: number;
  mobile: string;
  schoolName?: string;
  smsCode: string;
  credential: string;
  confirmCredential: string;
  curriculumSetup: {
    xkwStageId: number;
    xkwGradeId: number;
    xkwTerm: string;
    xkwVersionList: {
      stage_id: number;
      subject_id: number;
      course_id: number;
      version_id: number;
    }[];
  };
}

export default function AppRegister() {
  const checkRef = React.useRef<AgreeNegotiateRef | null>(null);
  const nameInputRef = useRef<any>();
  const [isShowSN, setIsShowSN] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const route = useRoute<RouteProp<RouteParamsList, 'Register'>>();
  const dispatch = useDispatch();
  const userInfo = useAppSelector(selectUserInfo);
  const navigation = useNavigation();
  const {uniqueId} = useGetDeviceInfo();
  const initialCodeNum = -1;
  const countdownNum = 60;
  const [codeNum, setCodeNum] = useState(initialCodeNum);
  // 根据isEdit修改页面标题
  useEffect(() => {
    const isEdit = route.params?.isEdit;
    navigation.setOptions({
      title: isEdit ? '修改信息' : '注册账号',
    });
  }, [navigation, route.params?.isEdit]);
  const genderList = [
    {
      name: '男孩',
      id: 1,
      icon: 'https://media.oss.leziedu.com/webapp/classroom/r/r_boy.png',
      aIcon: 'https://media.oss.leziedu.com/webapp/classroom/r/r_a_boy.png',
      styles: styles.itemStyleBoy,
    },
    {
      name: '女孩',
      id: 2,
      icon: 'https://media.oss.leziedu.com/webapp/classroom/r/r_gril.png',
      aIcon: 'https://media.oss.leziedu.com/webapp/classroom/r/r_a_gril.png',
      styles: styles.itemStyleGril,
    },
  ];
  const {control, handleSubmit, setValue, formState, getValues, watch} =
    useForm<FormData>({
      reValidateMode: 'onSubmit',
      defaultValues: {
        name: '',
        gender: 1,
        grade: 0,
        mobile: '',
        schoolName: '',
        smsCode: '',
        credential: '',
        confirmCredential: '',
        curriculumSetup: {
          xkwStageId: 0,
          xkwGradeId: 0,
          xkwTerm: '',
          xkwVersionList: [],
        },
      },
    });
  const selectedGender = watch('gender');
  const formProps = {
    name: {
      control,
      name: 'name' as const,
      rules: {
        required: {
          value: true,
          message: '请输入孩子的姓名',
        },
        pattern: {
          value: /^[\u4e00-\u9fa5]{1,5}$/,
          message: '姓名最长5个汉字',
        },
      },
    },
    gender: {
      control,
      name: 'gender' as const,
      rules: {
        required: {
          value: true,
          message: '请选择性别',
        },
      },
    },
    grade: {
      control,
      name: 'grade' as const,
      rules: {
        required: {
          value: true,
          message: '请选择年级',
        },
      },
    },
    mobile: {
      control,
      name: 'mobile' as const,
      rules: {
        required: {
          value: true,
          message: '请输入手机号',
        },
        pattern: {
          value: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
          message: '手机号格式不正确',
        },
      },
    },
    schoolName: {
      control,
      name: 'schoolName' as const,
    },
    smsCode: {
      control,
      name: 'smsCode' as const,
      rules: {
        required: {
          value: true,
          message: '请输入密码',
        },
      },
    },
    credential: {
      control,
      name: 'credential' as const,
      rules: {
        required: {
          value: true,
          message: '请输入密码',
        },
      },
    },
    confirmCredential: {
      control,
      name: 'confirmCredential' as const,
      rules: {
        required: {
          value: true,
          message: '请再次输入密码',
        },
        validate: {
          sameAsPassword: (value: any) => {
            if (value === getValues('credential')) {
              return true;
            } else {
              return '两次输入密码应相同';
            }
          },
        },
      },
    },
    curriculumSetup: {
      control,
      name: 'curriculumSetup' as const,
    },
  };
  const sendCode = () => {
    console.log(111, formState, getValues('mobile'));
    if (!getValues('mobile') || getValues('mobile') === '') {
      Toast.show({
        type: 'error',
        text1: '请输入手机号',
      });
      return;
    }
    sendCodeApi({
      mobile: getValues('mobile'),
      deviceSn: uniqueId,
    }).then(res => {
      if (res.status === 200) {
        Toast.show({
          type: 'success',
          text1: '验证码发送成功',
        });
        setCodeNum(countdownNum);
      } else {
        Toast.show({
          type: 'error',
          // @ts-ignore
          text1: res.msg as string,
        });
        return;
      }
    });
  };
  const onSubmit = (data: any) => {
    console.log('data', data);
    if (!checkRef.current?.getCheckState()) {
      return Toast.show({
        type: 'info',
        text1: '请先阅读并同意用户协议',
      });
    }
    setLoading(true);
    registerApi({
      ...data,
      registerDevice: uniqueId,
      curriculumSetup: data.curriculumSetup, // 添加课程设置信息
    }).then(res => {
      if (res.status === 200) {
        Toast.show({
          type: 'success',
          text1: '注册成功',
        });
        setTimeout(() => {
          // @ts-ignore
          navigation.replace('Login');
        }, 1000);
      } else {
        Toast.show({
          type: 'error',
          // @ts-ignore
          text1: res.msg as string,
        });
      }
      setLoading(false);
    });
  };
  useEffect(() => {
    if (route.params?.isEdit && userInfo) {
      // 编辑模式，设置所有值
      setValue('name', userInfo.name || '');
      setValue('gender', userInfo.gender ?? 0);
      setValue('schoolName', userInfo.schoolName ?? '');

      const curriculumSetup = {
        xkwStageId: userInfo.curriculumSetup?.xkwStageId ?? 0,
        xkwGradeId: userInfo.curriculumSetup?.xkwGradeId ?? 0,
        xkwTerm: userInfo.curriculumSetup?.xkwTerm ?? '',
        xkwVersionList:
          userInfo.curriculumSetup?.xkwVersionList?.map(item => ({
            stage_id: item.stage_id ?? 0,
            subject_id: item.subject_id ?? 0,
            course_id: item.course_id ?? 0,
            version_id: item.version_id ?? 0,
          })) ?? [],
      };

      setValue('curriculumSetup', curriculumSetup);
    } else {
      // 非编辑模式，清空除性别外的所有内容
      setValue('name', '');
      setValue('schoolName', '');
      setValue('mobile', '');
      setValue('smsCode', '');
      setValue('credential', '');
      setValue('confirmCredential', '');
      setValue('curriculumSetup', {
        xkwStageId: 0,
        xkwGradeId: 0,
        xkwTerm: '',
        xkwVersionList: [],
      });
    }
  }, [route.params?.isEdit, setValue, userInfo]);

  const onSave = (data: FormData) => {
    setLoading(true);
    updateUserApi({
      name: data.name,
      gender: data.gender,
      schoolName: data.schoolName,
      curriculumSetup: data.curriculumSetup as any, // 使��完整的 curriculumSetup
      id: userInfo.id,
    }).then(res => {
      if (res.status === 200) {
        Toast.show({
          type: 'success',
          text1: '更新成功',
        });
        dispatch(saveUserInfo(res.data));
        setTimeout(() => {
          // @ts-ignore
          navigation.dispatch(
            CommonActions.reset({
              index: 0,
              routes: [{name: 'ChatGPTAssist'}],
            }),
          );
        }, 1000);
      } else {
        Toast.show({
          type: 'error',
          // @ts-ignore
          text1: res.msg as string,
        });
      }
      setLoading(false);
    });
  };
  useEffect(() => {
    let timerId: string | number | NodeJS.Timeout | undefined;

    if (codeNum > 0) {
      timerId = setTimeout(() => {
        setCodeNum(codeNum - 1);
      }, 1000);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [codeNum]);
  // 显示错误
  useEffect(() => {
    const {errors} = formState;
    Object.keys(errors).some(k => {
      if ((errors as Record<string, FieldError>)[k]?.message) {
        Toast.show({
          type: 'error',
          text1: (errors as Record<string, FieldError>)[k]?.message as string,
        });
      }
      return (errors as Record<string, FieldError>)[k]?.message;
    });
  }, [formState]);
  // 检查设备
  // useEffect(() => {
  //   if (uniqueId) {
  //     checkSN(uniqueId).then(res => {
  //       if (res.status !== 200) {
  //         Toast.show({
  //           type: 'error',
  //           text1: res.msg,
  //         });
  //       } else {
  //         setIsShowSN(true);
  //       }
  //     });
  //   }
  // }, [uniqueId]);

  const isEdit = route.params?.isEdit;
  const [isGradeModalVisible, setIsGradeModalVisible] = useState(false);
  // 添加状态
  const [gradeList, setGradeList] = useState<Grade[]>([]);
  const [stages, setStages] = useState<Stage[]>([]);
  const [terms, setTerms] = useState<Term[]>([]);
  // 在组件加载时获取年级列表
  useEffect(() => {
    getCurriculumSetupInfos().then(res => {
      if (res.status === 200) {
        const allGrades = res.data.stages.reduce(
          (acc: Grade[], stage: Stage) => {
            return [...acc, ...stage.grades];
          },
          [],
        );
        setGradeList(allGrades);
        setStages(res.data.stages);
        setTerms(res.data.terms);
        if (route.params?.showModal) {
          setIsGradeModalVisible(true);
        }
      }
    });
  }, []);

  // 修改 gradeDisplayText 的计算逻辑
  const gradeDisplayText = useMemo(() => {
    // 直接监听所有需要的字段
    const curriculumSetup = watch('curriculumSetup');
    const gradeId = watch('curriculumSetup.xkwGradeId');
    const termId = watch('curriculumSetup.xkwTerm');
    const versionList = watch('curriculumSetup.xkwVersionList');

    if (isEdit && (gradeList.length === 0 || terms.length === 0)) {
      return '';
    }

    if (!curriculumSetup || !gradeId) {
      return '请选择年级、学期、教材版本';
    }

    const grade = gradeList.find(g => Number(g.id) === Number(gradeId));
    const term = terms.find(t => String(t.id) === String(termId));

    if (!grade?.name || !term?.name) {
      return '请选择年级、学期、教材版本';
    }

    const hasVersions = versionList && versionList.length > 0;

    return `${grade.name}、${term.name}${hasVersions ? '、版本已选择' : ''}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gradeList, terms, isEdit, watch('curriculumSetup')]);

  // 简化 handleGradeSelectorChange 函数
  const handleGradeSelectorChange = useCallback(
    (curriculumSetup: CurriculumSetup) => {
      setValue('curriculumSetup', curriculumSetup);
      setIsGradeModalVisible(false);
    },
    [setValue],
  );

  return (
    <ImageBackground
      style={styles.flex1}
      source={require('../../assets/images/bg1.png')}>
      {isShowSN ? <Text style={styles.snText}>设备号：{uniqueId}</Text> : null}
      <ScrollView
        keyboardShouldPersistTaps={'handled'}
        style={styles.registerContent}>
        <View style={styles.registerContentBox}>
          <View style={styles.registerContentBoxLeft}>
            <ItemComponent
              icon={
                'https://media.oss.leziedu.com/webapp/classroom/r/r_name.png'
              }>
              <View style={styles.itemStyleInput}>
                <Controller
                  {...formProps.name}
                  render={({field: {onChange, onBlur, value}}) => (
                    <Input
                      // 添加这两行
                      ref={nameInputRef}
                      onSubmitEditing={() => {
                        if (nameInputRef.current) {
                          nameInputRef.current.blur();
                        }
                      }}
                      onBlur={onBlur}
                      value={value}
                      onChangeText={onChange}
                      style={styles.textInput}
                      containerStyle={styles.input}
                      inputContainerStyle={{borderBottomWidth: 0}}
                      placeholder="请输入孩子的姓名"
                    />
                  )}
                />
              </View>
            </ItemComponent>
            <View style={{flexDirection: 'row'}}>
              <Controller {...formProps.gender} render={() => <></>} />
              {genderList.map((item, index) => {
                return (
                  // 可点击的
                  <TouchableOpacity
                    key={index}
                    activeOpacity={1}
                    onPress={() => {
                      console.log('id', item.id);
                      setValue('gender', item.id);
                      console.log('a_id', getValues('gender'));
                    }}>
                    <ItemComponent
                      key={index}
                      itemStyle={[
                        item.styles,
                        item.id === selectedGender &&
                          styles.itemStyleGenderActive,
                      ]}
                      icon={
                        item.id === selectedGender ? item.aIcon : item.icon
                      }>
                      <Text
                        style={[
                          styles.itemStyleText,
                          item.id === selectedGender &&
                            styles.itemStyleTextActive,
                        ]}>
                        {item.name}
                      </Text>
                    </ItemComponent>
                  </TouchableOpacity>
                );
              })}
            </View>
            <ItemComponent
              icon={
                'https://media.oss.leziedu.com/webapp/classroom/r/r_school.png'
              }>
              <View style={styles.itemStyleInput}>
                <Controller
                  {...formProps.schoolName}
                  render={({field: {onChange, onBlur, value}}) => (
                    <Input
                      onBlur={onBlur}
                      value={value}
                      onChangeText={onChange}
                      style={styles.textInput}
                      containerStyle={styles.input}
                      inputContainerStyle={{borderBottomWidth: 0}}
                      placeholder="请输入学校的完整名称（选填）"
                    />
                  )}
                />
              </View>
            </ItemComponent>
            <ItemComponent
              icon={
                'https://media.oss.leziedu.com/webapp/classroom/r/r_grade.png'
              }>
              <View style={styles.itemStyleInput}>
                <TouchableOpacity
                  style={styles.itemStyleGrade}
                  onPress={() => setIsGradeModalVisible(true)}>
                  <Text
                    style={[
                      styles.textInput,
                      styles.textBtn,
                      !watch('curriculumSetup.xkwGradeId') &&
                        styles.placeholderText,
                    ]}>
                    {gradeDisplayText}
                  </Text>
                </TouchableOpacity>
              </View>
            </ItemComponent>
          </View>
          <View style={styles.registerContentBoxZW} />
          {!isEdit ? (
            <View style={styles.registerContentBoxRight}>
              <ItemComponent
                icon={
                  'https://media.oss.leziedu.com/webapp/classroom/r/r_name.png'
                }>
                <View style={styles.itemStyleInput}>
                  <Controller
                    {...formProps.mobile}
                    render={({field: {onChange, onBlur, value}}) => (
                      <Input
                        onBlur={onBlur}
                        value={value}
                        onChangeText={onChange}
                        style={styles.textInput}
                        containerStyle={styles.input}
                        inputContainerStyle={{borderBottomWidth: 0}}
                        placeholder="请输入手机号码"
                      />
                    )}
                  />
                </View>
              </ItemComponent>
              <ItemComponent
                itemStyle={[styles.itemStyleInputDiyCode]}
                icon={
                  'https://media.oss.leziedu.com/webapp/classroom/r/r_code.png'
                }>
                <View style={styles.itemStyleInputCode}>
                  <Controller
                    {...formProps.smsCode}
                    render={({field: {onChange, onBlur, value}}) => (
                      <Input
                        onBlur={onBlur}
                        value={value}
                        onChangeText={onChange}
                        style={styles.textInput}
                        containerStyle={styles.itemStyleInputCodeLineInput}
                        inputContainerStyle={{borderBottomWidth: 0}}
                        placeholder="请输入验证码"
                      />
                    )}
                  />
                  <View style={styles.itemStyleInputCodeLine}>
                    <View style={styles.itemStyleInputCodeLineText} />
                  </View>
                  <Button
                    buttonStyle={styles.itemStyleInputCodeBtn}
                    titleStyle={styles.itemStyleInputCodeBtnText}
                    disabled={codeNum <= countdownNum && codeNum > 0}
                    size={'sm'}
                    title={
                      codeNum > 0 ? '获取验证码(' + codeNum + ')' : '获取验证码'
                    }
                    type="clear"
                    onPress={sendCode}
                  />
                </View>
              </ItemComponent>
              <ItemComponent
                icon={
                  'https://media.oss.leziedu.com/webapp/classroom/r/r_password.png'
                }>
                <View style={styles.itemStyleInput}>
                  <Controller
                    {...formProps.credential}
                    render={({field: {onChange, onBlur, value}}) => (
                      <Input
                        onBlur={onBlur}
                        value={value}
                        onChangeText={onChange}
                        style={styles.textInput}
                        secureTextEntry={true}
                        containerStyle={styles.input}
                        inputContainerStyle={{borderBottomWidth: 0}}
                        placeholder="请设置，数字、字母"
                      />
                    )}
                  />
                </View>
              </ItemComponent>
              <ItemComponent
                icon={
                  'https://media.oss.leziedu.com/webapp/classroom/r/r_rpassword.png'
                }>
                <View style={styles.itemStyleInput}>
                  <Controller
                    {...formProps.confirmCredential}
                    render={({field: {onChange, onBlur, value}}) => (
                      <Input
                        onBlur={onBlur}
                        value={value}
                        onChangeText={onChange}
                        style={styles.textInput}
                        secureTextEntry={true}
                        containerStyle={styles.input}
                        inputContainerStyle={{borderBottomWidth: 0}}
                        placeholder="请再次输入密码"
                      />
                    )}
                  />
                </View>
              </ItemComponent>
            </View>
          ) : null}
        </View>
        {!isEdit ? (
          <View style={styles.AgreeNegotiate}>
            <AgreeNegotiate
              ref={checkRef}
              customStyle={styles.AgreeNegotiateCustom}
            />
          </View>
        ) : null}
        <View>
          <Button
            loading={loading}
            loadingProps={{size: 35}}
            onPress={handleSubmit(isEdit ? onSave : onSubmit)}
            containerStyle={styles.registerBtnWrap}
            buttonStyle={styles.registerBtn}
            ViewComponent={LinearGradient} // Don't forget this!
            linearGradientProps={{
              style: {height: 100, flex: 1},
              colors: ['#9E99FF', '#6455FF'],
              start: {x: 0, y: 1},
              end: {x: 1, y: 0},
            }}>
            <Text style={styles.registerBtnText}>
              {!isEdit ? '注 册' : '保 存'}
            </Text>
          </Button>
        </View>
        <GradeSelector
          isVisible={isGradeModalVisible}
          onClose={() => setIsGradeModalVisible(false)}
          onChange={handleGradeSelectorChange}
          stages={stages}
          terms={terms}
          initialValues={watch('curriculumSetup')}
        />
      </ScrollView>
    </ImageBackground>
  );
}
const styles = createStyles({
  flex1: {
    flex: 1,
    alignItems: 'center',
  },
  snText: {
    position: 'absolute',
    top: '3.2rem',
    left: '6rem',
    fontSize: '1rem',
  },
  registerContent: {
    width: '89rem',
    paddingTop: '5.6rem',
  },
  registerContentBox: {
    backgroundColor: '#E5EDFC',
    borderRadius: '2.1rem',
    height: '36.1rem',
    paddingHorizontal: '3.33rem',
    paddingVertical: '3.54rem',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  registerContentBoxLeft: {
    flex: 1,
  },
  registerContentBoxZW: {
    width: '9.38rem',
  },
  registerContentBoxRight: {
    flex: 1,
  },
  AgreeNegotiate: {
    marginTop: '1.25rem',
  },
  AgreeNegotiateCustom: {
    justifyContent: 'flex-start',
  },
  registerBtnWrap: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '1.47rem',
  },
  registerBtn: {
    width: '23.07rem',
    height: '5.2rem',
    borderRadius: '3.39rem',
  },
  registerBtnText: {
    color: '#fff',
    fontSize: '1.77rem',
  },
  itemComponentBox: {
    height: '3.85rem',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: '0.78rem',
    paddingHorizontal: '0.78rem',
    marginBottom: '1.82rem',
  },
  itemComponentImage: {
    width: '2.08rem',
    height: '2.08rem',
    marginRight: '0.8rem',
  },
  itemStyleBoy: {
    width: '10.1rem',
    marginRight: '1.82rem',
  },
  itemStyleGenderActive: {
    backgroundColor: '#6455FF',
  },
  itemStyleText: {
    marginLeft: '0.78rem',
    fontSize: '1.35rem',
    color: '#333333',
  },
  itemStyleTextActive: {
    color: '#fff',
  },
  itemStyleGril: {
    width: '10.1rem',
  },
  itemStyleClass: {
    width: '5.68rem',
    justifyContent: 'center',
  },
  itemStyleClassActive: {
    backgroundColor: '#6455FF',
  },
  itemStyleTextClass: {
    fontSize: '1.04rem',
    color: '#333333',
  },
  itemStyleTextClassActive: {
    color: '#fff',
  },
  itemStyleInput: {
    width: '30rem',
    height: '100%',
  },
  itemStyleInputCode: {
    height: '3.85rem',
    width: '31rem',
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemStyleInputCodeLine: {
    width: '3.8rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  itemStyleInputCodeLineText: {
    height: '1.09rem',
    backgroundColor: '#666666',
    width: 1,
  },
  itemStyleInputCodeLineInput: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemStyleInputCodeBtn: {},
  itemStyleInputCodeBtnText: {
    fontSize: '1.35rem',
    color: '#999999',
  },
  itemStyleInputDiyCode: {
    paddingRight: 0,
  },
  textInput: {
    margin: 0,
    padding: 0,
    fontSize: '1.35rem',
    color: '#333333',
  },
  input: {
    height: '100%',
    flex: 1,
  },
  itemStyleGrade: {
    flex: 1,
    height: '100%',
    justifyContent: 'center',
  },
  placeholderText: {
    color: '#999999',
  },
  textBtn: {
    marginLeft: '1rem',
  },
});
